<!-- 定时管理控制对象 -->
<template>
   <div>
       <div>
            控制对象
            <el-radio-group v-model="radioValue" style="margin-left:15px;">
                <el-radio :label="1">单台控制</el-radio>
                <el-radio :label="2">组别控制</el-radio>
                <el-radio :label="3">所有设备</el-radio>
            </el-radio-group>
        </div>
        <template v-if="radioValue == 1">
            <div style="margin:20px 0;">
                选择业主
                <div style="width: 75%;margin-left: 15px;display:inline-block;">
                    <cmp-build-select
                            :buildRoom="buildRoom"
                            changeOnSelect
                            @listenBuildResult="listenBuildResult" ></cmp-build-select>
                </div>
                <div style="margin:15px 0;">
                    设备列表
                    <el-select v-model="oid" style="margin-left:15px;" filterable clearable placeholder="请选择">
                        <el-option
                            v-for="item in meterList"
                            :key="item.oid"
                            :label="item.terminal_serial + ':' + item.household_name"
                            :value="item.oid">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </template>
        <template v-if="radioValue == 2">
            <div style="margin:20px 0;">
                <el-transfer
                    filterable
                    :filter-method="filterMethod"
                    filter-placeholder="请输入关键字"
                    :titles="['全部组别', '已选组别']"
                    v-model="groupValue"
                    :data="groupData">
                </el-transfer>
            </div>
        </template>
        <template v-if="radioValue == 3">
            <div style="margin-top:20px;"></div>
        </template>
   </div>
</template>

<script>
import { mapGetters } from "vuex";
import Service from '@/api/Service'
import CmpBuildSelect from '@/components/CmpBuildSelect/CmpBuildSelect'

export default {
    name:  'CmpControlMeters',
    props: ["index", "parentData"],
    data() {
        
        return {
            // 控制对象
            radioValue: 1, // 1：单台控制，2：组别控制，3：所有
            roomarr:[],
			building_index:0,
            // 选择房间组件
            buildRoom: {},
            oid: '',
            meterList: [],
            buildingindex:'',
            // 组别穿梭框
            // groupData: [],
            groupValue: [],
            filterMethod(query, item) {
                return item.label.indexOf(query) > -1;
            },
        };
    },
    computed: {
        ...mapGetters(['timeDesc', "meterGroupList", "timeControlMeters"]),
        groupData() {
            let data = this.meterGroupList;
            if(data) {
                let arr = [];
                data.map(v=>{
                    // 过滤设备型号分组
                    if(v.devtype === this.timeDesc.devtype) {
                        arr.push({
                            key: v.oid,
                            label: v.groupname
                        })
                    }
                })
                return arr;
            }
            return []
        }
    },
    components: {
        CmpBuildSelect
    },
    watch: {
        index(newVal, oldVal) {
            if(newVal == 4 && oldVal == 3) {
                // 保存
                this.next()
            }
        },
        parentData(newVal) {
            this.initData(newVal)
        }
    },
    created() {
        this.initData(this.parentData)
		this.gettemp()
    },
    
    methods: {
		gettemp(){
			this.$store.dispatch("GetProjectInfo").then(async res => {
			    // 获取模型结构
			    Service.getTemplate({oid:res.buildings_template_id}).then(async ress => {
					this.roomarr = this.fmdata(JSON.parse(ress.description))
			    })
			}).catch(res=>{
				
			})
		},
		fmdata(data){
			return data.reduce((arr, { id, typename, children = [] }) =>
				arr.concat([{ id, typename }], this.fmdata(children)), [])
		},
        initData(data) {
            this.radioValue = data.type;
            if(data.type == 1) {
                this.oid = data.OID
                this.getTerminalbyidInfo(data.OID);
            }
            if(data.type == 2) {
                this.groupValue = data.groupValue
            }
            
        },
        next() {
            let data = this.fmtData()
            if(data.data.length) {
				if(data.type == 1 && data.data[0].value =='') {
					this.$message({
						type:'warn',
						message: "请选择控制对象",
					})
					this.$emit("next", false);
				}else{
					this.$store.dispatch("setControlMeters", data)
					this.$emit("next", true);
				}
            }else{
                this.$message({
                    type:'warn',
                    message: "请选择控制对象",
                })
                this.$emit("next", false);
            }
        },
        //  获取楼层下面全部表计
        async listenBuildResult(item) {
			let ishouse =false
			if(item.householdid === undefined) {
			    // 建筑
			    ishouse = false
				let list=this.roomarr.filter(v=>{
					return v.typename == item.typename
				})
				this.buildingindex=list[0].id + 1
			}else{
				// 房间
			   ishouse = true
               this.buildingindex=this.roomarr.length
			}
			
            // if(true) {
                // 根据房间获取
                let data = await Service.getBindingMeter({moduleid: item.oid,is_house:ishouse,buildingindex:this.buildingindex,page_num:1,page_sum:1000});
                if(data) {
                    data = data =='success' ? [] : data.list;
                    this.meterList = data.filter(v=>{
                        return v.dev_type === this.timeDesc.devtype
                    })
                }else{
                    this.meterList = []
                    this.$message({
                        type: "warn",
                        message: '该建筑下没有绑定任何设备，请重新选择建筑'
                    })
                }
                return
            // }
            // // 根据楼宇
            // let data = await Service.getMeterDeviceList({moduleid: item.oid});
            // data = data === 'success' ? [] : data;
            // if(data.length>0){
            //     // 筛选出楼层下相应表计
            //     this.meterList = data.filter(v=>{
            //         return v.DevType === this.timeDesc.devtype
            //     })
            // }else{
            //     this.meterList = []
            //     this.$message({
            //         type: "warn",
            //         message: '该楼宇下没有绑定任何设备，请重新选择楼宇'
            //     })
            // }
        },

         // 获取组别
        async getGroup() {
            let data = this.meterGroupList;
			console.log(data)
            if(data) {
                data = data === 'success' ? [] : data;
                let arr = [];
                data.map(v=>{
                    // 过滤设备型号分组
                    if(v.devtype === this.timeDesc.devtype) {
                        arr.push({
                            key: v.oid,
                            label: v.groupname
                        })
                    }
                })
                this.groupData = arr;
            }
        },

        // 获取表计信息
        async getTerminalbyidInfo(oid) {
            let res = await Service.getTerminalbyidInfo({oid: oid})
            if(res) {
                res = res === 'success' ? [] : res;
                this.meterList = res;
            }
        },

        fmtData(){
            let obj = {};
			var contname=''
            obj.type = this.radioValue;
			if(obj.type == 1){
				var list =this.meterList.filter(v=>{
					return this.oid ===v.oid
				})
				if(list[0]){
					contname = list[0].terminal_serial + ":" + list[0].household_name
				}
				obj.controlname =contname
			}else if(obj.type == 2){
				this.groupValue.map(v=>{
					var group =this.groupData.filter(v1=>{
					return v1.key === v
				})
					if(group[0]){
						contname = contname + group[0].label + "  "
					}
					
				})
				obj.controlname =contname
			}else{
				obj.controlname = '控制全部'
			}
			
            obj.data = []
            switch (obj.type) {
                case 1:
                    obj.data.push({value: this.oid})
                    break;
                case 2:
                    this.groupValue.map(v=>{
                        obj.data.push({value: v})
                    })
                    break;
                case 3:
                    obj.data.push({value: 0})
                    break;
                default:
                    break;
            }
            return obj
        }
    }
}

</script>
<style lang='less' scoped>

</style>